function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "logo");

var SvgLogoWhite = function SvgLogoWhite(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    viewBox: "0 0 499.7 403.16",
    ref: svgRef
  }, props), _ref2, React.createElement("path", {
    d: "M529.85,330.45c-.83,3.75-1.72,7.49-2.48,11.25-10.81,53.07-39.93,90.47-84,114.53-29.27,16-60.78,23.83-93.35,25-25.11.93-50.28-.38-75.42-.71-.29,0-.58-.28-1-1.44,14.16-1.75,28.29-3.75,42.47-5.18,25.55-2.59,51.17-4.9,75.28-15.44,41-17.93,69.87-48.49,80.77-96.08,8.36-36.52,1.54-70.64-17.12-102C421.13,203.46,373.29,166.61,314.41,146c-31.13-10.88-62.85-19.08-95.74-20.27-26.72-1-52.61,4.66-78.36,11.84-33.16,9.25-60.81,27.75-83.06,55.93-.31.38-.74.66-2.3,2,2.45-6.64,4.19-12,6.37-17.16,14.88-35,39.2-59.6,71.87-73.74C181.87,83.59,232.51,74.54,284.87,80c55.29,5.73,104.61,28.35,148.69,64.63,25,20.6,48.42,43.22,66.81,71.18a176.94,176.94,0,0,1,28.55,78.76,8.92,8.92,0,0,0,.93,2.26Z",
    transform: "translate(-30.15 -78.42)",
    style: {
      fill: "#a0a0a0"
    }
  }), React.createElement("path", {
    d: "M30.15,292.12c1.21-4.92,2.45-9.84,3.64-14.76,11.75-48.57,43.73-80.13,93.23-97.2,42.3-14.59,85.77-17.57,130.07-11.58,40.41,5.46,78.1,18,111.66,40.11,33.16,21.86,59,49.44,74.4,84.93l-.88.65c-11.35-10.57-22.17-21.7-34.16-31.57-27-22.21-58.78-36.9-92.26-48.23-76.05-25.74-148.27-17.9-215.73,23.9-29.19,18.09-49.6,42.68-55.18,75.7-2.23,13.15-1,26.81-1.32,40.25a33.5,33.5,0,0,1,.08,4.27c-6-9-9.37-18.81-11.5-29.08a60.86,60.86,0,0,0-2.05-6.39Z",
    transform: "translate(-30.15 -78.42)",
    style: {
      fill: "#a0a0a0"
    }
  }), React.createElement("path", {
    d: "M224.09,470.07a209.77,209.77,0,0,1-75-20.71C113,431.91,83.7,409.41,66.18,378.51c-24.87-43.86-7.68-90.22,44.07-116.07,41-20.47,86.26-28.1,134.59-24.42,34.46,2.63,66.79,11.23,98.47,21.68a2.84,2.84,0,0,1,1.92,1.8c-2-.19-4.1-.33-6.13-.58-2.3-.28-4.57-.68-6.86-1-43.19-6.06-86.15-6.89-128.62,3.48-29.62,7.24-55.19,19.25-73.88,39.2-30.17,32.2-29.56,74.8,2.32,109.89,22.09,24.33,51.2,42.27,85.47,55.05C219.73,468.36,221.9,469.23,224.09,470.07Z",
    transform: "translate(-30.15 -78.42)",
    style: {
      fill: "#a0a0a0"
    }
  }), React.createElement("path", {
    d: "M178.32,419.74c-25.21-10.2-42.52-27.69-46.56-55.13-4.09-27.73,6-50.74,29.28-66.45,21.53-14.51,44.41-13.38,68.29-1.9-6.62,1.64-12.25,2.87-17.78,4.43-30.5,8.62-48.9,28.41-54.45,59.71-2.73,15.37,1.44,29.38,9.79,42.22,3.7,5.7,8,11,12.05,16.49Z",
    transform: "translate(-30.15 -78.42)",
    style: {
      fill: "#a0a0a0"
    }
  }), React.createElement("path", {
    d: "M415.53,312.93l-.06,1.51-.76-.87Z",
    transform: "translate(-30.15 -78.42)",
    style: {
      fill: "#a0a0a0"
    }
  }), React.createElement("path", {
    d: "M186.26,445l.42,1-1-.39Z",
    transform: "translate(-30.15 -78.42)",
    style: {
      fill: "#a0a0a0"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_white.ae3e1b5a.svg";
export { ForwardRef as ReactComponent };